module.exports = __webpack_public_path__ + "static/media/conduct.c580f34a.md";